const container = document.querySelector('.header');
const menuItems = document.querySelectorAll('.mega-menu');

function updateHeaderState() {
  const isAnyOpen = Array.from(menuItems).some(item => item.hasAttribute('open'));
  container.classList.toggle('active', isAnyOpen);
}

// Set up observer
const observer = new MutationObserver(updateHeaderState);

// Observe each .mega-menu for attribute changes
menuItems.forEach(item => {
  observer.observe(item, { attributes: true, attributeFilter: ['open'] });
});

// Initial check
updateHeaderState();

// Mobile menu toggle

// document.querySelector('.close-btn-mobile-menu').addEventListener('click', function () {
//   const menuDrawer = document.querySelector('.menu-drawer-container');
  
//   if (menuDrawer) {
//     menuDrawer.classList.remove('open', 'menu-opening');
//     menuDrawer.removeAttribute('open');
//   }
// });

 document.addEventListener("DOMContentLoaded", function () {
    const progressBar = document.querySelector(".progress-bar");
    const current = parseFloat(progressBar.getAttribute("data-count")) || 0;
    const max = 60;
    const percentage = Math.min((current / max) * 100, 100);
    progressBar.style.width = percentage + "%";
  });


document.addEventListener("DOMContentLoaded", function () {
  document.body.classList.remove("preload");
});


// illustration animation

document.addEventListener("DOMContentLoaded", function () {
  const imageContainers = document.querySelectorAll(".multiple-img-banner-section");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // Stop observing after activating
        }
      });
    },
    {
      threshold: 0.1 // Adjust as needed
    }
  );

  imageContainers.forEach((container) => {
    observer.observe(container);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const imageContainers = document.querySelectorAll(".text-with-multiple-image-section");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // Stop observing after activating
        }
      });
    },
    {
      threshold: 0.1 // Adjust as needed
    }
  );

  imageContainers.forEach((container) => {
    observer.observe(container);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.menu-drawer-item-title-wrapper').forEach(wrapper => {
    wrapper.addEventListener('click', function () {
      const parent = wrapper.closest('.menu-drawer-item');
      const content = parent.querySelector('.menu-drawer--submenu');
      const isActive = parent.classList.contains('active');

      document.querySelectorAll('.menu-drawer-item').forEach(item => {
        item.classList.remove('active');
        item.querySelector('.menu-drawer--submenu').style.maxHeight = null;
      });

      if (!isActive) {
        parent.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

  document.querySelectorAll('.nested-accordion-title').forEach(title => {
    title.addEventListener('click', function () {
      const item = title.closest('.nested-accordion-item');
      const content = item.querySelector('.nested-accordion-content');
      const parentSubmenu = item.closest('.menu-drawer--submenu');
      const isActive = item.classList.contains('active');

      item.parentElement.querySelectorAll('.nested-accordion-item').forEach(sib => {
        sib.classList.remove('active');
        sib.querySelector('.nested-accordion-content').style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";

        setTimeout(() => {
          parentSubmenu.style.maxHeight = parentSubmenu.scrollHeight + "px";
        }, 300); // Match transition duration
      }
    });
  });
});
